/** Translate-to-English (demo-v2 W4) — /api/translate.
 *
 * Dark behind the backend's translation_enabled flag: the namespace 404s
 * while off, so a probe on it IS the flag read (rk/register idiom). One
 * direction, on demand, cached server-side by content hash — the first
 * click pays one call, repeats are instant.
 */

import { useEffect, useState } from 'react'
import { ApiError, apiFetch } from '../../lib/api'

export interface TranslateResponse {
  translated: string
  cached: boolean
}

export function translateText(text: string): Promise<TranslateResponse> {
  return apiFetch<TranslateResponse>('/api/translate', {
    method: 'POST',
    body: JSON.stringify({ text }),
  })
}

/* ── flag probe ──────────────────────────────────────────────────────── */

let probe: Promise<boolean> | null = null

export function probeTranslation(): Promise<boolean> {
  if (!probe) {
    probe = apiFetch<{ max_chars: number }>('/api/translate')
      .then(() => true)
      .catch((err) => {
        if (err instanceof ApiError && err.status === 404) return false
        // Auth/network hiccups must not latch the flag off for the session.
        probe = null
        return false
      })
  }
  return probe
}

/** null while probing, then the flag. */
export function useTranslationEnabled(): boolean | null {
  const [enabled, setEnabled] = useState<boolean | null>(null)
  useEffect(() => {
    let cancelled = false
    probeTranslation().then((on) => {
      if (!cancelled) setEnabled(on)
    })
    return () => {
      cancelled = true
    }
  }, [])
  return enabled
}
